// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uz","a":"uA","searchingKids":"uB"};